import { HomepageV3Header, HomepageV3Footer } from './components/HomepageV3Chrome'

// Keep issued confirmation/unsubscribe URLs useful without reading their token.
export default function WeeklyMenuActionPage() {
  return <div className="sg-v3 weekly-menu-action">
    <a className="skip-link" href="#main-content">Skip to main content</a>
    <HomepageV3Header cartCount={0} />
    <main id="main-content" className="weekly-menu-action__main" tabIndex={-1}>
      <h1>Weekly marketing emails have been discontinued</h1>
      <p>No action is needed. We no longer accept weekly marketing email sign-ups or send weekly marketing emails.</p>
      <p>Order, payment, delivery and support messages continue.</p>
      <p>Existing consent and unsubscribe records are preserved. This page does not change an individual subscription record.</p>
      <p><a href="/privacy">Privacy Policy</a> · <a href="/contact">Contact Sugar Gremlin</a></p>
    </main>
    <HomepageV3Footer />
  </div>
}
